import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select,
    Popconfirm,
    Form,
    Radio,
    Switch,
    Cascader,
    TreeSelect,
    notification,Spin,
    message, Table, Tag, Statistic
} from 'antd';
import { EditOutlined, DeleteOutlined, WechatOutlined } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
import cookie from "react-cookies";
const { Title,Text } = Typography;
const { Content } = Layout;
const { Meta } = Card;
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '添加成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const info = () => {
    message.info('This is a normal message');
};
const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '金额（元）',
        dataIndex: 'fund_value',
        key: 'fund_value',
    },
    {
        title: '状态',
        dataIndex: 'name',
        key: 'name',
        render: (_, { fund_type }) => (
            <>
                {fund_type == 1
                    ?
                    <Tag color='success'>
                        增加
                    </Tag>
                    :
                    <Tag color='error'>
                        减少
                    </Tag>
                }
            </>
        ),
    },
    {
        title: '备注',
        dataIndex: 'fund_intro',
        key: 'fund_intro',
    },
    {
        title: '时间',
        dataIndex: 'fund_pubtime',
        key: 'fund_pubtime',
    }
];
class PageFinFund extends Component{

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        let userId = cookie.load('userId');
        this.state = {
            title: "资金管理",
            county: [],
            id: id,
            type: 1,
            userId: userId,
            sum: 0,
            list: [],
            loading: true,
            month: moment().format('YYYY-MM')
        };
    }

    componentDidMount() {
        var id = this.state.id
        var day = moment().format('DD')/*
        var start = moment().format("YYYY-MM") + '-26'*/
        var end = moment().add(1, "days").format("YYYY-MM-DD")/*
        var month = moment().add(1, "months").format('YYYY-MM')
        if(day < 26){
            start = moment().subtract(1, "months").format("YYYY-MM") + '-26'
            month = moment().format('YYYY-MM')
        }*/
        var start = moment().format("YYYY-MM") + '-01'
        var month = moment().format('YYYY-MM')
        this.setState({
            month: month
        });
        if(id) {
            fetch("https://pd.pokemonbye.com:8084/api/getsellfundsumbyclient?id=" + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        let list = result.data;
                        if(list!=null&&list.length>0){

                            this.setState({
                                isLoaded: true,
                                sum: list[0]
                            });
                            fetch("https://pd.pokemonbye.com:8081/api/getweightmaxbyname?name=" + list[0].client_name + "&start=" + start + "&end=" + end)
                                .then(res => res.json())
                                .then(
                                    (result) => {
                                        let array = result.data;
                                        var sumsum = 0
                                        var sumvalue = 0
                                        var summax = list[0].fund_sum
                                        if(array!=null&&array.length>0){

                                            fetch("https://pd.pokemonbye.com:8084/api/getsellclientdate?client=" + id + "&start=" + start + "&end=" + end)
                                                .then(res => res.json())
                                                .then(
                                                    (result) => {

                                                        if(result!=null&&result.length>0){

                                                            if (result != null && result.length > 0) {
                                                                for (let i = 0; i < array.length; i++) {
                                                                    for (let j = 0; j < result.length; j++) {
                                                                        if (array[i].time.substring(0, 10) == result[j].date) {
                                                                            for (let k = 0; k < result[j].list.length; k++) {
                                                                                if (array[i].stock == result[j].list[k].stockname) {
                                                                                    array[i].price = result[j].list[k].value
                                                                                    array[i].max = array[i].price * array[i].value
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    sumsum += array[i].max
                                                                    sumvalue += parseFloat(array[i].value)
                                                                }
                                                            }
                                                            sumsum = sumsum.toFixed(2)
                                                            summax = summax - sumsum
                                                            console.log(summax)
                                                            fetch("https://pd.pokemonbye.com:8084/api/getsellfundbyclient?id=" + id)
                                                                .then(res => res.json())
                                                                .then(
                                                                    (result) => {
                                                                        let array = result.data;
                                                                        console.log(array)
                                                                        let top = {
                                                                            "fund_value":sumsum,
                                                                            "fund_type":0,
                                                                            "fund_intro":"提货流水",
                                                                            "fund_pubtime": this.state.month
                                                                        }
                                                                        array.unshift(top)
                                                                        if(array!=null&&array.length>0){

                                                                            for (let i = 0; i < array.length; i++) {
                                                                                array[i].key = i + 1;
                                                                            }
                                                                        }
                                                                        this.setState({
                                                                            loading: false,
                                                                            list: array,
                                                                            summax: summax.toFixed(2)
                                                                        });
                                                                    },
                                                                    // 注意：需要在此处处理错误
                                                                    // 而不是使用 catch() 去捕获错误
                                                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                                                    (error) => {
                                                                        this.setState({
                                                                            loading: false,
                                                                            error
                                                                        });
                                                                    }
                                                                )

                                                            this.setState({
                                                                loading: false
                                                            });
                                                        }
                                                    },
                                                    // 注意：需要在此处处理错误
                                                    // 而不是使用 catch() 去捕获错误
                                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                                    (error) => {
                                                        this.setState({
                                                            loading: false,
                                                            error
                                                        });
                                                    }
                                                )
                                        }else{
                                            fetch("https://pd.pokemonbye.com:8084/api/getsellfundbyclient?id=" + id)
                                                .then(res => res.json())
                                                .then(
                                                    (result) => {
                                                        let array = result.data;
                                                        console.log(array)
                                                        let top = {
                                                            "fund_value":sumsum,
                                                            "fund_type":0,
                                                            "fund_intro":"提货流水",
                                                            "fund_pubtime": this.state.month
                                                        }
                                                        array.unshift(top)
                                                        if(array!=null&&array.length>0){

                                                            for (let i = 0; i < array.length; i++) {
                                                                array[i].key = i + 1;
                                                            }
                                                        }
                                                        this.setState({
                                                            loading: false,
                                                            list: array,
                                                            summax: summax.toFixed(2)
                                                        });
                                                    },
                                                    // 注意：需要在此处处理错误
                                                    // 而不是使用 catch() 去捕获错误
                                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                                    (error) => {
                                                        this.setState({
                                                            loading: false,
                                                            error
                                                        });
                                                    }
                                                )
                                        }
                                    },
                                    // 注意：需要在此处处理错误
                                    // 而不是使用 catch() 去捕获错误
                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                    (error) => {
                                        this.setState({
                                            loading: false,
                                            error
                                        });
                                    }
                                )
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            loading: false,
                            error
                        });
                    }
                )
        }
    }
    formRef = React.createRef();
    render() {
        const handleChange = (value) => {
            this.setState({
                type: value
            });
        };
        const onFinish = (values) => {

            function queryParse(query){
                let queryText = "";
                for(let key in query){
                    queryText += `${key}=${query[key]}&`;
                }
                return queryText.slice(0,-1);
            }
            var list = {};
            list.fund_value = values.value ? values.value : 0;
            list.fund_num = 0;
            list.fund_type = this.state.type ? this.state.type : 1;
            list.fund_admin = this.state.userId ? this.state.userId : '';
            list.fund_intro = '管理员操作';
            if(this.state.id){
                list.fund_client = this.state.id;
                fetch("https://pd.pokemonbye.com:8084/api/insertsellfund",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();
                            window.location.reload();
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Row>
                                    <Col span={4}>
                                    </Col>
                                    <Col span={4}>
                                        <Spin spinning={this.state.loading}>
                                        <Card>
                                            {
                                                this.state.summax > 0
                                                ?
                                                    <Statistic
                                                        title={this.state.sum.client_name}
                                                        value={this.state.summax}
                                                        precision={2}
                                                        valueStyle={{
                                                            color: '#3f8600',
                                                        }}
                                                        suffix="元"
                                                    />
                                                    :
                                                    <Statistic
                                                        title={this.state.sum.client_name}
                                                        value={this.state.summax}
                                                        precision={2}
                                                        valueStyle={{
                                                            color: '#cf1322',
                                                        }}
                                                        suffix="元"
                                                    />
                                            }
                                        </Card>
                                        </Spin>
                                    </Col>
                                    <Col span={16}>
                                        <Form
                                            labelCol={{
                                                span: 4,
                                            }}
                                            wrapperCol={{
                                                span: 10,
                                            }}
                                            layout="horizontal"
                                            size="Large"
                                            onFinish={onFinish}
                                            ref={this.formRef}
                                        >
                                            <Form.Item label="状态" name="type">
                                                <Select
                                                    defaultValue="增加"
                                                    style={{
                                                        width: 120,
                                                    }}
                                                    options={[
                                                        {
                                                            value: '1',
                                                            label: '增加',
                                                        },
                                                        {
                                                            value: '0',
                                                            label: '减少',
                                                        }
                                                    ]}
                                                    onChange={handleChange}
                                                />
                                            </Form.Item>
                                            <Form.Item label="金额" name="value"
                                                       rules={[
                                                           {
                                                               required: true,
                                                               message: '请输入金额!',
                                                           },
                                                       ]}>
                                                <InputNumber prefix="￥" addonAfter="元"/>
                                            </Form.Item>
                                            <Form.Item
                                                wrapperCol={{
                                                    offset: 4,
                                                    span: 16,
                                                }}
                                            >
                                                <Button type="primary" htmlType="submit">{this.state.id?'添加':'新建'}</Button>
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                                <br/>

                                <Table bordered={true} columns={columns} dataSource={this.state.list}/>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageFinFund;


